import React, { useEffect, useState } from "react";
import ImageCarousel from "../../../components/ImageCarousel";
import classes from "./index.module.css";
import AppLogo from "../../../assets/images/mainLogo.png";
import { pageLoader } from "../../../Redux/actions/user-actions";
import { api } from "../../../api-calls/user-requests";
import { UPDATE_WORK_INFO } from "../../../api-calls/api-urls";
import {
  Alphabetic,
  Numeric,
  fetchLocation,
} from "../../../utilities/commonFunctions";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import "../../../assets/css/style.css";
import { Card, MenuItem, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLanguagedataFunction } from "../../../utilities/language";
import { Industries } from "../../Home/MyProfile/Industries";

const RegisterCompany = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [companyName, setCompanyName] = useState("");
  const [designation, setDegignation] = useState("");
  const [GSTnumber, setGSTnumber] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [pincode, setPincode] = useState("");
  const [industry, setIndustry] = useState("plumbing");
  const [industryName, setIndustryName] = useState("");
  const [location, setLocation] = useState();
  const regUser = JSON.parse(sessionStorage.getItem("CurrentUser"));

  const ln = useSelector((state) => state.allUsers.language_json);

  useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  useEffect(() => {
    if (pincode && pincode?.length === 6) {
      fetchLocation(pincode, setLocation);
    } else {
      setLocation();
    }
  }, [pincode]);

  const handleSubmit = async () => {
    console.log("triggered");
    if (companyName !== "" && address1 !== "" && pincode !== "") {
      const userEntry = {
        user_id: regUser._id,
        company_name: companyName,
        designation: designation,
        gst_number: GSTnumber,
        address_one: address1,
        address_two: address2,
        pin: pincode,
        industry: industry !== "others" ? industry : industryName,
      };
      dispatch(pageLoader(true));
      const { data } = await api.post(UPDATE_WORK_INFO, userEntry);
      sessionStorage.setItem("CompanyDatas", JSON.stringify(data));
      navigate("/set-password");
    }
  };
  const handleIndustry = (value) => {
    setIndustry(value);
    if (value !== "others") {
      setIndustryName("");
    }
  };
  return (
    <div className={classes.maindivForlogin}>
      {ln ? (
        <Card className={classes.SelectLanguage_maindiv}>
          <div>
            <ImageCarousel />
          </div>
          <Box className="scrollbaroverflow" sx={{ width: '100%' }}>
            <div style={{ padding: "3rem" }}>
              <div className="text-left">
                <Box component="span" className="logo-lg" sx={{ mb: 3 }}>
                  <img src={AppLogo} alt="" height="50" />
                </Box>
                <Typography className={classes.activeLAnguageBtn} sx={{ mt: 2 }}>
                  {ln.verified_email_and_mobile}
                </Typography>
                <Box sx={{ display: 'flex' }}>
                  <Typography className={classes.boldContainer} sx={{ mt: 1 }}>
                    <span className={classes.loginDescription}>
                      +91 {regUser?.phone}
                    </span>{" "}
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                        fill="#0A1F41"
                      />
                    </svg>
                  </Typography>
                  &nbsp; &nbsp;
                  {regUser ? (
                    <Typography className={classes.boldContainer} sx={{ mt: 1 }}>
                      <span className={classes.loginDescription}>
                        {regUser?.email}
                      </span>{" "}
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                          fill="#0A1F41"
                        />
                      </svg>
                    </Typography>
                  ) : null}
                </Box>
              </div>
              <Typography className={classes.loginHeading} sx={{ mt: 3 }}>
                {ln.company_details}
              </Typography>
              <Typography className={classes.loginDescription} sx={{ mt: 3 }}>
                {ln.enter_companydetails_to_continue}
              </Typography>
              <ValidatorForm useref="form" onSubmit={console.log("triggered")}>
                <Box sx={{ mt: 3 }}>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                    <Box sx={{ width: '50%', pr: 1 }}>
                      <Box sx={{ mb: 2 }}>
                        <label
                          htmlFor="firstNameinput"
                          className={classes.login_form_lable}
                        >
                          {ln.company_name}
                        </label>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "100%",
                          }}
                          id="firstNameinput"
                          value={companyName}
                          onChange={(e) => setCompanyName(e.target.value)}
                          onKeyPress={(e) => Alphabetic(e)}
                          size="small"
                          validators={["required"]}
                          errorMessages={["Company Name is required"]}
                        />
                      </Box>
                    </Box>
                    <Box sx={{ width: '50%', pl: 1 }}>
                      <Box sx={{ mb: 2 }}>
                        <label
                          htmlFor="lastNameinput"
                          className={classes.login_form_lable}
                        >
                          {ln.designation} ({ln.optional})
                        </label>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "100%",
                          }}
                          id="lastNameinput"
                          value={designation}
                          onChange={(e) => setDegignation(e.target.value)}
                          onKeyPress={(e) => Alphabetic(e)}
                          size="small"
                        />
                      </Box>
                    </Box>
                    <Box sx={{ width: '50%', pr: 1 }}>
                      <Box sx={{ mb: 2 }}>
                        <label
                          htmlFor="phonenumberInput"
                          className={classes.login_form_lable}
                        >
                          {ln.gst_number} ({ln.optional})
                        </label>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "100%",
                          }}
                          id="phonenumberInput"
                          value={GSTnumber}
                          onChange={(e) => setGSTnumber(e.target.value)}
                          size="small"
                          validators={[
                            "matchRegexp:^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$",
                          ]}
                          errorMessages={["This is not a valid GST Number"]}
                        />
                      </Box>
                    </Box>
                    <Box sx={{ width: '50%', pl: 1 }}>
                      <Box sx={{ mb: 2 }}>
                        <label
                          htmlFor="emailidInput"
                          className={classes.login_form_lable}
                        >
                          {ln.address1}
                        </label>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "100%",
                          }}
                          id="emailidInput"
                          value={address1}
                          onChange={(e) => setAddress1(e.target.value)}
                          size="small"
                          validators={["required"]}
                          errorMessages={["Address 1 is required"]}
                        />
                      </Box>
                    </Box>
                    <Box sx={{ width: '50%', pr: 1 }}>
                      <Box sx={{ mb: 2 }}>
                        <label
                          htmlFor="address1ControlTextarea"
                          className={classes.login_form_lable}
                        >
                          {ln.address2} ({ln.optional})
                        </label>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "100%",
                          }}
                          id="address1ControlTextarea"
                          value={address2}
                          onChange={(e) => setAddress2(e.target.value)}
                          size="small"
                        />
                      </Box>
                    </Box>
                    <Box sx={{ width: '50%', pl: 1 }}>
                      <Box sx={{ mb: 2, position: "relative" }}>
                        <label
                          htmlFor="address1ControlTextarea"
                          className={classes.login_form_lable}
                        >
                          {ln.pin}
                        </label>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "100%",
                          }}
                          id="address1ControlTextarea"
                          value={pincode}
                          onChange={(e) => setPincode(e.target.value)}
                          onKeyPress={(e) => Numeric(e)}
                          size="small"
                          inputProps={{
                            maxLength: 6,
                          }}
                          validators={["required"]}
                          errorMessages={["PinCode is required"]}
                        />
                        {location && (
                          <Typography
                            className={`${classes.login_form_lable} ${classes.countryPinLable}`}
                          >
                            {location}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box sx={{ width: '50%', pr: 1 }}>
                      <Box sx={{ mb: 2 }}>
                        <label
                          htmlFor="address1ControlTextarea"
                          className={classes.login_form_lable}
                        >
                          {ln.industry}
                        </label>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "100%",
                          }}
                          select
                          value={industry}
                          onChange={(e) => handleIndustry(e.target.value)}
                          required={true}
                          size="small"
                        >
                          {Industries.map((option, index) => (
                            <MenuItem key={index} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                          <MenuItem key={"others"} value={"others"}>
                            Others
                          </MenuItem>
                        </TextValidator>
                      </Box>
                    </Box>
                    {/* <Box sx={{ width: '50%', pl: 1, display: disabled }}>
                      <Box sx={{ mb: 2 }}>
                        <label
                          htmlFor="address1ControlTextarea"
                          className={classes.login_form_lable}
                        >
                          {ln.industry_name}
                        </label>
                        <TextValidator
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                            width: "100%",
                          }}
                          id="address1ControlTextarea"
                          value={industryName}
                          onChange={(e) => setIndustryName(e.target.value)}
                          onKeyPress={(e) => Alphabetic(e)}
                          size="small"
                          validators={["required"]}
                          errorMessages={["Industry Name is is required"]}
                        />
                      </Box>
                    </Box> */}
                  </Box>
                </Box>
                <Box sx={{ mt: 3 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    className={classes.commonbtn}
                    onClick={() => handleSubmit()}
                  >
                    {ln.continue}
                  </Button>
                </Box>
              </ValidatorForm>
            </div>
          </Box>
        </Card>
      ) : null}
    </div>
  );
};

export default RegisterCompany;
